<div [ngClass]="loading ? 'visually-hidden': ''">
  <div class="container col-lg-8" style="background-color: #eaf2eb;">
    <app-search-simple-form [searchForm]="searchForm"></app-search-simple-form>
  </div>
  <app-announcements-view [messages]="announcements"></app-announcements-view>
</div>